/*
 * サイト内検索のキーワードを「語ごとの引用符つき」に整える。
 * 引用符つきの検索はキーワードを含む商品だけを返すため、入力語をそのまま含む商品だけを表示できる。
 * ヘッダーの検索フォーム（snippets/header-search.liquid）と検索結果ページ（sections/main-search.liquid）の両方から使う。
 */
(function () {
  if (window.SearchKeyword) return;

  // 利用者が打った引用符（半角・全角の左右）
  var QUOTE_CHARS = /["“”]/g;
  var HAS_QUOTE = /["“”]/;

  // 引用符を外し、全角スペースを半角にして、連続する空白を1つにする
  // Shopify は全角スペースを区切りとして扱わないため、半角に直してから分割する
  function strip(raw) {
    return String(raw || '')
      .replace(QUOTE_CHARS, '')
      .replace(/　/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // 語ごとに引用符で囲む（例：ケニア　Washed → "ケニア" "Washed"）。複数語は AND になる
  // 空なら空文字を返す。q="" で検索すると全商品が出るため、空は囲まない
  function quote(raw) {
    var keyword = strip(raw);
    if (!keyword) return '';
    return keyword
      .split(' ')
      .map(function (word) {
        return '"' + word + '"';
      })
      .join(' ');
  }

  // 検索結果ページで移す先の URL を返す。移す必要が無ければ null
  // zeroQuoted: 引用符つきの検索で0件だった（main-search.liquid で判定）
  function resolveResultUrl(href, zeroQuoted) {
    var url = new URL(href);
    var params = url.searchParams;
    var changed = false;

    // type=product なしだと件数・ページ送りが商品以外を含むため揃える
    if (params.get('type') !== 'product') {
      params.set('type', 'product');
      changed = true;
    }

    // 通常の検索へ切り替え済みのページでは、引用符を付け直さない
    if (params.get('fallback') === '1') {
      return changed ? url.toString() : null;
    }

    var q = params.get('q') || '';
    var quoted = quote(q);

    if (quoted !== q && (quoted || HAS_QUOTE.test(q))) {
      // ブックマーク・URL 直打ちなどで引用符が無いまま来た場合
      params.set('q', quoted);
      changed = true;
    } else if (!changed && zeroQuoted && HAS_QUOTE.test(q)) {
      // キーワードを含む商品が0件なら、引用符を外した通常の検索へ切り替える
      params.set('q', strip(q));
      params.set('fallback', '1');
      params.delete('page');
      changed = true;
    }

    return changed ? url.toString() : null;
  }

  // 送信時に引用符を付ける。表示中の検索窓の値は変えずに、組み立てた URL へ移る
  function bindForm(form) {
    form.addEventListener('submit', function (event) {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var quoted = quote(input.value);
      // 空ならそのまま送る（いまと同じ動き）
      if (!quoted) return;

      event.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      params.set('q', quoted);
      window.location.assign(form.action.split('?')[0] + '?' + params.toString());
    });
  }

  function bindForms() {
    var forms = document.querySelectorAll('form[data-search-keyword]');
    for (var i = 0; i < forms.length; i++) {
      bindForm(forms[i]);
    }
  }

  window.SearchKeyword = {
    strip: strip,
    quote: quote,
    resolveResultUrl: resolveResultUrl,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForms);
  } else {
    bindForms();
  }
})();
